<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group label="Category">
      <b-form-checkbox
        v-for="option in categoryOptions"
        :key="option._id"
        v-model="categoryFilterValue"
        :value="option._id"
        name="retail-item-category-filter"
      >
        {{ option.name }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
  },
  props: {
    category: {
      type: [Array, null],
      default: null,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      categoryFilterValue: JSON.parse(JSON.stringify(this.category)) || [],
    }
  },
  watch: {
    category: {
      immediate: true,
      handler(val) {
        this.categoryFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:category', this.categoryFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.categoryFilterValue = []

      this.$emit('update:category', this.categoryFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>
